import { useContext } from 'react';

import { SephoraContext } from 'components/sephora/SephoraWrapper';

export const useSephoraContext = () => useContext(SephoraContext);

export default useSephoraContext;
